import { render, staticRenderFns } from "./ShiftEdit.vue?vue&type=template&id=37b59df7&"
import script from "./ShiftEdit.vue?vue&type=script&lang=js&"
export * from "./ShiftEdit.vue?vue&type=script&lang=js&"
import style0 from "./ShiftEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports